import { useEffect } from 'react';

interface ServiceSchemaProps {
  services?: string[];
}

export const ServiceSchema = ({ 
  services = ["plumber", "electrician", "heating engineer", "carpenter", "builder", "painter", "handyman", "roofer", "tiler"]
}: ServiceSchemaProps) => {
  useEffect(() => {
    const serviceStructuredData = services.map(service => ({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": `${service.charAt(0).toUpperCase() + service.slice(1)} Services`,
      "description": `Professional ${service} services across the UK with fast response guarantee. Verified, insured tradesmen ready to help with emergency and planned work.`,
      "provider": {
        "@type": "Organization",
        "name": "Sortable",
        "url": "https://sortable.uk",
        "logo": "https://sortable.uk/lovable-uploads/new-logo.png"
      },
      "serviceType": `${service} services`,
      "areaServed": {
        "@type": "Country",
        "name": "United Kingdom"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": `${service.charAt(0).toUpperCase() + service.slice(1)} Services`,
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": `Emergency ${service} services`,
              "description": `24/7 emergency ${service} services with fast response guarantee`
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service", 
              "name": `Planned ${service} work`,
              "description": `Scheduled ${service} services for home improvement and maintenance`
            }
          }
        ]
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "GBP",
        "price": "0",
        "name": "Free Quote",
        "description": "Free quotes from verified local tradesmen"
      }
    }));

    const scriptId = 'service-structured-data';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      document.head.appendChild(script);
    }
    
    script.textContent = JSON.stringify(serviceStructuredData);

    return () => {
      const script = document.getElementById(scriptId);
      if (script) {
        script.remove();
      }
    };
  }, [services]);

  return null;
};